import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getCookie, setCookie, deleteCookie } from '../utils/Cookie'
import commonConfig from '../configs/common'
import { checkTokenAuth} from '@/service/user/AuthService'
import { getSiteConfigByProfile } from '@/utils/SiteConfig'
export const useAuthStore = defineStore('auth', () => {

  const user = ref(null)
  const isAuthenticated = ref(false)
  const isCheckingAuth = ref(false)
  
  // 初始化函数（服务端和客户端通用）
  const initAuth = async (token) => {
    if (!token) {
      token = getCookie(null, commonConfig.authTokenName)
    }
    if (token) {
      try {
        isCheckingAuth.value = true
        // 只要有token就认为已登录
        isAuthenticated.value = true
        isCheckingAuth.value = false
        return true
      } catch (error) {
        clearAuth()
        isCheckingAuth.value = false
        return false
      }
    }
    return isAuthenticated.value
  }
  
  // 设置认证状态
  const setAuth = (userData, token) => {
    user.value = userData
    isAuthenticated.value = true
    // 设置cookie（客户端）
    if (typeof window !== 'undefined') {
      setCookie(commonConfig.authTokenName, token, { 
        path: '/',
        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) // 7天
      })
    }
  }
  
  // 清除认证状态
  const clearAuth = () => {
    user.value = null
    isAuthenticated.value = false
    if (typeof window !== 'undefined') {
      deleteCookie(commonConfig.authTokenName, { path: '/' })
    }
  }
  
  // 登录
  const login = async (credentials) => {
    try {
      // 真实登录逻辑请在业务层实现
      return false
    } catch (error) {
      console.error('登录失败:', error)
      return false
    }
  }
  
  // 登出
  const logout = async () => {
    clearAuth()
  }
  
  // 检查认证状态（通过Cookie中的token判断）
  const checkAuth = async () => {
    isCheckingAuth.value = true
    // 检查Cookie中是否有token
    const token = getCookie(null, commonConfig.authTokenName)
    if (token) {
      // 校验token有效性
      const curLanguage = `${__SITE_PROFILE__}`
      const siteConfig = await getSiteConfigByProfile(curLanguage)
      const schoolId = siteConfig.schoolId
      const res = await checkTokenAuth({ schoolId, token})
      if (res.code === 1 && res.data && res.data.effective) {
        // token 有效，直接用返回的用户信息
        user.value = {
          userId: res.data.userId,
          userRole: res.data.userRole,
          nickName: res.data.nickName,
          imageUrl: res.data.imageUrl
        }
        isAuthenticated.value = true
        isCheckingAuth.value = false
        return true
      } else {
        // token 失效，清除
        deleteCookie(null, commonConfig.authTokenName)
        user.value = null
        isAuthenticated.value = false
        isCheckingAuth.value = false
        return false
      }
    }
    isCheckingAuth.value = false
    return false
  }
  
  return {
    user,
    isAuthenticated,
    isCheckingAuth,
    initAuth,
    login,
    logout,
    clearAuth,
    checkAuth,
    setAuth
  }
})